/**
 * dexAutoUpdatePref — "update my Pokédex from what I scan" (2026-08-28 ask).
 *
 * Governs the My Pokémon → Pokédex cross-write (myPokemonDexCrossWrite): when
 * ON (the default, matching the behaviour that always shipped), a scanned or
 * imported Pokémon ticks its species' dex cells automatically. When OFF the
 * cross-write is a no-op everywhere at once, because the gate lives inside
 * crossWriteMyPokemonToDex itself rather than at each call site.
 *
 * Same localStorage + broadcast-event pattern as eventDexGapsPref, so the
 * Settings switch and any listening surface flip together.
 */

const STORAGE_KEY = "nexus.dexAutoUpdateFromScans.v1";
export const DEX_AUTO_UPDATE_EVENT = "nexus:dex-auto-update-changed";

/** Default ON: cross-writes are the long-standing shipped behaviour. */
export function isDexAutoUpdateEnabled(): boolean {
  try {
    if (typeof localStorage === "undefined") return true;
    return localStorage.getItem(STORAGE_KEY) !== "off";
  } catch {
    return true;
  }
}

export function setDexAutoUpdateEnabled(enabled: boolean): void {
  try {
    if (enabled) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, "off");
  } catch {
    /* storage blocked: the in-session default still applies */
  }
  try {
    window.dispatchEvent(new Event(DEX_AUTO_UPDATE_EVENT));
  } catch {
    /* SSR */
  }
}
